<script setup>
    import { defineProps, computed } from 'vue'
    import { useCurrency } from '../composables/currency'
    import { useLocale } from '../composables/locale'
    
    const { currency } = useCurrency()
    const { intlNumberFormat } = useLocale()

    const props = defineProps({
        value: {
            required: true,
            default: () => 0
        },

        currency: {
            required: false,
            default: () => null
        }
    })

    const currencyString = computed(() => new Intl.NumberFormat(intlNumberFormat.value, {
            style: 'currency',
            currency: props.currency ?? currency.value
        })
        .format(props.value)
    )
</script>

<template>
    <span class="storefront__currency">
        {{ currencyString }}
    </span>
</template>
